import { useEffect, useRef } from 'react'
import styles from './ScrollProgress.module.css'

export function ScrollProgress() {
  const progressRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    let frameId = 0

    const update = () => {
      frameId = 0
      const scrollRange = document.documentElement.scrollHeight - window.innerHeight
      const progress = scrollRange > 0 ? window.scrollY / scrollRange : 0
      progressRef.current?.style.setProperty(
        '--page-progress',
        String(Math.min(1, Math.max(0, progress))),
      )
    }

    const requestUpdate = () => {
      if (!frameId) {
        frameId = requestAnimationFrame(update)
      }
    }

    update()
    window.addEventListener('scroll', requestUpdate, { passive: true })
    window.addEventListener('resize', requestUpdate)

    return () => {
      window.removeEventListener('scroll', requestUpdate)
      window.removeEventListener('resize', requestUpdate)
      cancelAnimationFrame(frameId)
    }
  }, [])

  return (
    <div className={styles.track} aria-hidden="true">
      <span ref={progressRef} className={styles.progress} />
    </div>
  )
}
